import getApi from '../../api/apisauceConfig'
import { DocumentCategoryKeys } from '../../model/DocumentCategory'
import { FwDocumentType } from '../../model/Document'
import { ApiErrorContent } from '../../model/Error'

export interface InteropSyncableDocumentResource {
  documentId: number
  type: FwDocumentType
  documentCategoryId: DocumentCategoryKeys
}

export interface InteropSyncableFileResource {
  fileId: number
}

export interface SyncDocumentsInteropPayload {
  medicalEventId: number
  documents: InteropSyncableDocumentResource[]
  files: InteropSyncableFileResource[]
}

export interface SyncDocumentsInteropResponse {
  message: string
}

export const syncDocumentsInterop = (serial: string, payload: SyncDocumentsInteropPayload) =>
  getApi().post<SyncDocumentsInteropResponse, ApiErrorContent>(
    `/interop/patients/${serial}/sync-documents`,
    payload,
  )
